module.exports = __webpack_public_path__ + "img/icon_category_06.3b82b56f.svg";